import React, { useEffect, useMemo, useState } from "react";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import { useTranslation } from "react-i18next";

const CHECK_OUT_CONDITIONS = ["good", "okay", "ready", "external-repair"];

const isCheckOutCondition = (condition) => {
  return CHECK_OUT_CONDITIONS.includes(condition);
};

const TrailerOutSearchSelect = ({ onSelect, selectedTrailer, required=true }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const filterOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 1) return [];

    try {
      const res = await instance.get(
        `assets/view-trailers?name=${inputValue}&q=10`
      );
      return res.data.map((event) => ({
        ...event.trailer,
        internal_seal: event.internal_seal,
        value: event.trailer.id,
        label: isCheckOutCondition(
          event.trailer.trailer_condition.toLowerCase()
        )
          ? event.trailer.trailer_number
          : `${event.trailer.trailer_number} (${t(
              `forms.type.vehicle.select.trailerCondition.${event.trailer.trailer_condition.toLowerCase()}`
            )})`,
        isDisabled: !isCheckOutCondition(
          event.trailer.trailer_condition.toLowerCase()
        ),
      }));
    } catch (err) {
      console.error("Failed to fetch trailers: ", err);
      return [];
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (selectedTrailer) filterOptions(selectedTrailer.label);
    setIsLoading(false);
  }, []);

  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000); // 500ms debounce

    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      aria-label="Trailer"
      inputId="trailer-select"
      name="trailer"
      loadingMessage={() => t("general.loading")}
      defaultOptions={false}
      isLoading={isLoading}
      value={selectedTrailer}
      loadOptions={debouncedLoadOptions}
      onChange={(option) => onSelect(option)}
      placeholder={t("forms.type.vehicle.search.trailer.search")}
      noOptionsMessage={() => t("forms.type.vehicle.search.trailer.not-found")}
      isClearable
      className="search-select"
      styles={customStyles}
      unstyled={true}
      required={required}
    />
  );
};

export default TrailerOutSearchSelect;
